var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserHeadset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "#ffffff",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M704 704h-46.2a348.16 348.16 0 0 1-291.6 0H320A256 256 0 0 0 64 960a64 64 0 0 0 64 64h768a64 64 0 0 0 64-64 256 256 0 0 0-256-256zM160 448a32 32 0 0 0 32-32v-32c0-176.44 143.56-320 320-320s320 143.56 320 320v32a160.18 160.18 0 0 1-160 160h-64a64 64 0 0 0-64-64h-64a64 64 0 0 0 0 128h192a224.28 224.28 0 0 0 224-224v-32C896 172.26 723.74 0 512 0S128 172.26 128 384v32a32 32 0 0 0 32 32z m320 0h64a128 128 0 0 1 110.82 64H672a96.1 96.1 0 0 0 96-96v-32a256 256 0 0 0-512 0c0 80.84 38.2 152 96.7 198.94-0.12-2.34-0.7-4.56-0.7-6.94a128.14 128.14 0 0 1 128-128z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHeadset);
export default __webpack_public_path__ + "static/media/user-headset.483f6a5f5dec329c58242eca959dcab2.svg";
export { ForwardRef as ReactComponent };